import { supabase } from '@/integrations/supabase/client';

export async function fetchDevelopmentTasks<T>(): Promise<T[]> {
  const { data, error } = await supabase
    .from('development_tasks')
    .select('*')
    .order('created_at', { ascending: false });

  if (error) throw new Error('Unable to load development tasks');
  return (data ?? []) as T[];
}
